import api from "./axios";

export const listCompetitions = (page = 1, opts = {}) => {
  const q = new URLSearchParams({ page: String(page) });
  if (opts.search) q.set("search", opts.search);
  if (opts.tournament) q.set("tournament", opts.tournament);
  return api.get(`/api/competitions/competitions/?${q.toString()}`);
};

export const getCompetition = (id) =>
  api.get(`/api/competitions/competitions/${id}/`);

export const createCompetition = (payload) =>
  api.post("/api/competitions/competitions/", payload);

export const updateCompetition = (id, payload) =>
  api.put(`/api/competitions/competitions/${id}/`, payload);

export const deleteCompetition = (id) =>
  api.delete(`/api/competitions/competitions/${id}/`);

export const updateCompetitionTeams = (competitionId, teamIds) =>
  api.post(`/api/competitions/competitions/${competitionId}/teams/`, {
    team_ids: teamIds,
  });

export const updateCompetitionSquad = (competitionTeamId, playerIds) =>
  api.post(`/api/competitions/competition-teams/${competitionTeamId}/squad/`, {
    player_ids: playerIds,
  });
